/**
 * Copyright (C) 2021 - 2024 Philips Domestic Appliances Holding B.V.
 * All rights are reserved.
 */

export const AttributeMetadata = Symbol('AttributeMetadata') as any;
